// src/components/About.jsx
import React, { useEffect, useState } from 'react';
import img1 from '../assets/aboutUs1.jpeg';
import img2 from '../assets/aboutUs2.jpg';
import img3 from '../assets/aboutUs3.jpg';
import img4 from '../assets/abouUs4.jpeg';
import '../styles/AboutUs.css';

const About = () => {
  const images = [img1, img2, img3, img4];

  const [currentIndex, setCurrentIndex] = useState(0);
  const [nextIndex, setNextIndex] = useState(1);
  const [isTransitioning, setIsTransitioning] = useState(false);

  useEffect(() => {
    const intervalId = setInterval(() => {
      const upcomingIndex = (currentIndex + 1) % images.length;
      setNextIndex(upcomingIndex);
      setIsTransitioning(true);

      setTimeout(() => {
        setCurrentIndex(upcomingIndex);
        setIsTransitioning(false);
      }, 900);
    }, 5000);

    return () => clearInterval(intervalId);
  }, [currentIndex, images.length]);

  return (
    <section id="about" className="about-section">
      <div className="about-container">
        <div className="about-text">
          <p className="about-eyebrow">SOBRE FVS CATERING</p>

          <h2 className="about-title">Nosotros</h2>

          <p className="about-paragraph">
            Ya sea un evento corporativo, un festejo familiar o el servicio diario en su hogar,
            en FVS Catering llevamos la excelencia gastronómica a donde usted la necesite.
            Nos especializamos en servicios de catering personalizados donde la calidad del
            producto y la precisión técnica son los protagonistas.
          </p>

          <a href="#services" className="about-button">
            Ver Servicios
          </a>
        </div>

        <div className="about-image-wrapper">
          <div className="about-image-stack">
            <img
              src={images[currentIndex]}
              alt={`Sobre FVS Catering ${currentIndex + 1}`}
              className={`about-img about-img-base ${isTransitioning ? 'fade-out' : 'visible'}`}
            />

            <img
              src={images[nextIndex]}
              alt={`Sobre FVS Catering ${nextIndex + 1}`}
              className={`about-img about-img-overlay ${isTransitioning ? 'fade-in' : ''}`}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;